<table>
  <th>{{ hasObisCode() ? 'OBIS' : 'Typ' }}</th>
  <th>Stand alt</th>
  <th>Stand neu</th>
  @if (hasAnyUnit()) {
  <th>Einheit</th>
  } @let meterType = this.meterType(); @for (counter of counters(); track counter.lastValue) {
  @if(counter.obis) {
  <tr>
    <td>
      {{ counter | counterDescription: meterType }}
    </td>
    <td>{{ counter.lastValue }}</td>
    <td>{{ counter.lastReading?.value ?? '-' }}</td>
    <td>{{ counter | obisUnit: meterType }}</td>
  </tr>
  } }
</table>
